/* eslint-disable react/no-unescaped-entities */
import { LegalShell } from "./LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service" updated="February 18, 2026">
      <p>
        These Terms of Service ("Terms") form a binding agreement between you and <strong>b→come</strong>
        ("we", "us", "our") and govern your use of the b→come website, mobile web app, and any related
        services (together, the "Service"). By creating an account or using the Service you agree to
        these Terms. If you do not agree, do not use the Service.
      </p>

      <h2>1. What b→come is (and is not)</h2>
      <p>
        b→come is an AI-powered personal-growth and life-planning tool. It gives you frameworks,
        suggestions, plans, and encouragement generated by artificial intelligence.
      </p>
      <p>
        <strong>b→come is not a substitute for professional advice.</strong> In particular, it is
        <strong> not medical, mental-health, financial, legal, or tax advice</strong>. For any
        significant decision — especially around health, mental wellbeing, money, or legal matters —
        please consult a qualified licensed professional. If you are in crisis, contact your local
        emergency services or a crisis hotline immediately.
      </p>

      <h2>2. Your account</h2>
      <ul>
        <li>You must be at least 13 years old to create an account. If you are between 13 and 18 you must have permission from a parent or guardian.</li>
        <li>You are responsible for keeping your login credentials confidential and for all activity that happens under your account.</li>
        <li>Provide accurate information at sign-up and keep it up to date.</li>
        <li>One person, one account. Do not share accounts or sell access.</li>
      </ul>

      <h2>3. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for anything illegal, harmful, harassing, hateful, or infringing on someone else's rights.</li>
        <li>Attempt to access accounts, data, or systems that are not yours.</li>
        <li>Reverse-engineer, scrape, or bulk-download the Service, its content, or its models.</li>
        <li>Use the Service to generate content that is defamatory, sexually explicit involving minors, promotes self-harm or violence, or otherwise violates our AI providers' content policies.</li>
        <li>Interfere with, disrupt, or overload the Service (including automated queries, spam, or denial-of-service).</li>
        <li>Resell or repackage the Service without a written commercial agreement with us.</li>
      </ul>
      <p>We may suspend or terminate accounts that violate these rules, with or without notice.</p>

      <h2>4. Subscriptions, billing &amp; refunds</h2>
      <ul>
        <li>b→come offers a Free plan and paid plans (Plus, Pro, Elite). Paid plans renew automatically at the interval you select until you cancel.</li>
        <li>You can cancel at any time from Settings. Cancellation takes effect at the end of the current billing period; you keep access until then.</li>
        <li>Free trials, when offered, convert automatically to a paid subscription at the end of the trial unless you cancel before it ends.</li>
        <li>All fees are non-refundable except where required by law. If we make a material adverse change to a paid feature you rely on, contact us and we will consider a pro-rata refund in good faith.</li>
        <li>Prices, features, and plan limits may change with reasonable prior notice.</li>
      </ul>

      <h2>5. Your content</h2>
      <p>
        You keep ownership of everything you create in b→come — your goals, journal entries,
        vision-board items, uploaded images and videos, coach messages, and any other content
        ("Your Content").
      </p>
      <p>
        You grant us a worldwide, royalty-free licence to host, process, display back to you, and
        transmit Your Content for the sole purpose of operating and improving the Service (including
        sending necessary context to our AI providers). We do not sell Your Content or use it to train
        third-party foundation models.
      </p>
      <p>You are responsible for having the necessary rights to any content you upload.</p>

      <h2>6. AI-generated output</h2>
      <p>
        Output produced by the Service (plans, coaching replies, insights, generated images) is
        provided as-is. AI can be inaccurate or biased and may occasionally produce content that is
        wrong, offensive, or unsuitable. You are responsible for reviewing AI output before acting on
        it. We make no warranty that AI output is accurate, complete, safe, or fit for any particular
        purpose.
      </p>
      <p>
        Subject to these Terms and applicable law, you are free to use AI output generated for you
        inside the Service in your personal life. Do not use it in a way that violates Section 3 or
        that misrepresents AI-generated content as human-authored where doing so would deceive others.
      </p>

      <h2>7. Third-party integrations</h2>
      <p>
        You may connect third-party services such as Google (Sign-In, Calendar), Facebook, Plaid, and
        others. Your use of those services is governed by their own terms and privacy policies. We are
        not responsible for third-party services, and if you disconnect them your access to features
        that depend on them will stop.
      </p>

      <h2>8. Intellectual property</h2>
      <p>
        The Service — including its software, design, brand, logos, copy, and pre-generated content —
        is owned by b→come and its licensors and is protected by copyright, trademark, and other laws.
        Except as explicitly permitted, you may not copy, modify, or create derivative works from the
        Service.
      </p>

      <h2>9. Disclaimers</h2>
      <p>
        <strong>The Service is provided "as is" and "as available" without warranties of any kind,
        whether express or implied.</strong> To the maximum extent permitted by law, we disclaim all
        warranties, including merchantability, fitness for a particular purpose, non-infringement,
        accuracy, availability, and any warranty arising from course of dealing or usage of trade.
        We do not warrant that the Service will be uninterrupted, timely, secure, error-free, or that
        AI output will meet your requirements.
      </p>

      <h2>10. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, in no event will b→come, its owners, employees, or
        service providers be liable for any indirect, incidental, special, consequential, exemplary,
        or punitive damages, or for lost profits, revenue, data, or goodwill, arising from or in
        connection with your use of the Service — even if we have been advised of the possibility of
        such damages.
      </p>
      <p>
        Our aggregate liability for any claims arising from or relating to the Service will not exceed
        the greater of (a) the amount you paid us in the twelve months before the event giving rise
        to the claim, or (b) US $100.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify and hold b→come harmless from any claim, demand, loss, or expense
        (including reasonable legal fees) arising out of (a) your use of the Service, (b) Your Content,
        or (c) your violation of these Terms or of any law or third-party right.
      </p>

      <h2>12. Termination</h2>
      <p>
        You may stop using the Service and delete your account at any time. We may suspend or terminate
        your access if you violate these Terms, if we are required to do so by law, or if we
        discontinue the Service. Sections that by their nature should survive termination will do so
        (including Sections 5, 8, 9, 10, 11, and 13).
      </p>

      <h2>13. Governing law &amp; disputes</h2>
      <p>
        These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict
        of laws principles. Any dispute arising from or relating to the Service or these Terms will be
        resolved in the state or federal courts located in Delaware, and you consent to the personal
        jurisdiction of those courts. Nothing in this section limits any mandatory consumer-protection
        rights you have under the laws of your country of residence.
      </p>

      <h2>14. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. If we make material changes we will notify you
        via email or an in-app notice and update the "Last updated" date at the top. Continuing to use
        the Service after the changes take effect means you accept the updated Terms.
      </p>

      <h2>15. Contact</h2>
      <p>
        Questions about these Terms? Email us at{" "}
        <a href="mailto:hello@b-come.ai">hello@b-come.ai</a>.
      </p>
    </LegalShell>
  );
}
